import { IdService } from './id.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Network } from '@capacitor/network';
import { Preferences } from '@capacitor/preferences';

@Injectable({
  providedIn: 'root'
})
export class HttpCacheService {

  status = null;
  handler;
  loaderElement;

  constructor(
      private httpClient: HttpClient,
      private idService: IdService,) {

    this.getStatus();
    if (this.handler === undefined) {
      this.handler = Network.addListener('networkStatusChange', (status) => {
        const oldStatus = this.status;
        this.status = status;
        if (this.status.connected && !oldStatus.connected) {
          // now connected, before was not connected
        }
        this.status = status;
        if (!this.status.connected) {
          // this.sharedService.showNotification('Network connection has terminated.', 'danger', 5000);
          // not connected
        }
      });
    }
  }

  public async setItem(key, value) {
    return await Preferences.set({key, value});
  }

  public async setStorageRequest2(request) {
    const cacheKey = 'reqcache-' + this.idService.generate();
    return await Preferences.set({key:cacheKey, value:JSON.stringify(request)});
  }


  public async isValueInStorage(value) {
    const valuesInStorage = [];

    const storageKeys = await Preferences.keys().then(async keys => Promise.all(keys.keys.map(async key => {
        if (key.includes('reqcache')) {
            const request = await Preferences.get({key}).then(_value => {
              const requestValue = JSON.parse(_value.value);
              requestValue.key = key;
              const timeString = +requestValue.key.split('-')[1];
              requestValue.time = new Date(timeString);
              valuesInStorage.push(requestValue);
            });
        }
      })));
    const valueObj = JSON.parse(value);
    const isValueRepeat = valuesInStorage.filter(e => JSON.stringify(e.body) === JSON.stringify(valueObj.body)).length > 0;
    return isValueRepeat;
  }

  public async setStorageRequest(request) {
    // this.sharedService.showNotification('User is offline. Service Request Cached', 'warning', 2000);
    const isValueInStorage = await this.isValueInStorage(JSON.stringify(request));
    if (!isValueInStorage && request.value !== null) {
      const cacheKey = 'reqcache-' + new Date().getTime() + '-' + request.urlWithParams;
      return Preferences.set({key:cacheKey, value:JSON.stringify(request)});
    } else {
      console.log('Request already cached');
    }
  }

  public async get(settingName){
    return await Preferences.get({key:`setting:${ settingName }`});
  }

  public async get2(settingName) {
    return await Preferences.get({key:settingName});
  }

  public async remove(settingName){
    return await Preferences.remove({key:settingName});
  }

  public async getKeys() {
    return await Preferences.keys();
  }

  public async getStatus() {
    this.status = await Network.getStatus();
  }


}
